export default function Footer() {
  const footerNav = [
    { label: '首页', href: '#hero' },
    { label: '实时快讯', href: '#updates' },
    { label: '大瓜排行榜', href: '#ranking' },
    { label: '分类索引', href: '#index' },
    { label: '专题报道', href: '#carousel' },
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
    { label: '常见问题', href: '#faq' },
  ];

  const partners = [
    '合作伙伴招募中',
    '合作伙伴招募中',
    '合作伙伴招募中',
    '合作伙伴招募中',
    '合作伙伴招募中',
    '合作伙伴招募中',
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <span className="font-heading text-xl text-background-50 mb-3 block">
                51今日大瓜
              </span>
              <p className="text-sm text-foreground-400 leading-relaxed">
                每日更新最火热门大瓜合集，精选今日大瓜排行榜与吃瓜精华。热门爆料汇总一站速览，追求信息密度和新鲜度。让每一个吃瓜群众都能第一时间掌握最新热门事件动态。
              </p>
            </div>

            <div>
              <p className="text-sm font-medium text-background-100 mb-4">快速导航</p>
              <div className="grid grid-cols-2 gap-2">
                {footerNav.map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-sm text-foreground-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <p className="text-sm font-medium text-background-100 mb-4">合作伙伴</p>
              <div className="grid grid-cols-3 gap-2">
                {partners.map((p, idx) => (
                  <div
                    key={idx}
                    className="bg-foreground-800 rounded py-2 px-2 text-center text-xs text-foreground-500"
                  >
                    {p}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 51今日大瓜 · 热门大瓜合集平台 · 所有内容均来自公开信息整理
            </p>
            <p className="text-xs text-foreground-600">
              吃瓜有度 · 理性围观 · 不信谣不传谣
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}